module.exports = __webpack_public_path__ + "img/page_activasolo_header.722279c4.png";